import React from 'react';
import { cn } from '@/shadcn/lib/utils';

interface GridEmptyStateProps extends React.HTMLAttributes<HTMLDivElement> {
  message: string;
  icon?: React.ReactNode;
  description?: string;
  action?: React.ReactNode;
}

const GridEmptyState = React.forwardRef<HTMLDivElement, GridEmptyStateProps>(
  ({ message, icon, description, action, className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'text-center text-gray-500 py-8', // sensible default styling
        className
      )}
      {...props}
    >
      {icon && <div className="mb-4 flex justify-center">{icon}</div>}
      <p className="text-lg font-medium">{message}</p>
      {description && <p className="text-sm mt-2">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  )
);

GridEmptyState.displayName = 'GridEmptyState';

export { GridEmptyState };
